import React, { Component } from 'react';
import card from '../../images/icons/ico_cc_def.png';
import cardVisa from '../../images/icons/ico_cc_visa.png';
import {withTranslation} from 'react-i18next'
import StripeElementsProvider from './StripeElementsProvider';
import { setCardStatusPopupProps } from "../../action/autoCheckin";
import { connect } from 'react-redux';
import { CARD_CAN_BE_CHARGED, CMSPath } from '../../../config/constant';

class AddCard extends Component{

    constructor(props){
        super(props)
        this.state = {
            cardverified: (localStorage.getItem('cardVerfied') == "true"),
            errorInCardverification: false
        }
    }

    componentDidMount(){
        let cardverified = (localStorage.getItem('cardVerfied') == "true")
        if(cardverified == 'true'){
            // this.props.next()
            this.props.setCardStatusPopupProps({
                cardStatus: true,
                statusTitle: 'Success',
                statusMessage1: 'Card verified successfully',
                statusMessage2: 'Please proceed to next steps'
            })
            // this.props.showCardVerified(true)
        }
    }

    render(){
        const {t} = this.props
        return(
            <div>
                <header className="inner-pages w-footer subpages">
                    <a className="button-back" onClick = {this.props.backBtn}></a>
                    <div className="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${this.props.logo}`} />
                        </div>
                        {/* <p className="bold" style = {{color:"inherit"}}>{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
                    </div>
                </header>
                <section className="widgets padding-0 margin-0 container-bg">

                    <div class="widget-header widget-header-checkin-inner">
                        { this.props.currentWidgetObj.widgetHeaderImageUrl && 
                            <div class="widget-header-img">
                                <img src={`${CMSPath}${this.props.currentWidgetObj.widgetHeaderImageUrl}`} alt={this.props.currentWidgetObj.displayName} />
                            </div>
                        }
                        <div class="widget-header-title">{this.props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div>
                    </div>

                    <div className="widgets">
                        <div className="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                            <h2>{t('check_in.booking_details')}</h2>
                        </div>
                        { !this.state.cardverified ?
                        <div className="form-window">
                            <div className="form-window-heading">
                            {t('check_in.card_details')}
                            </div>
                            <div className="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                            <p>{ CARD_CAN_BE_CHARGED ? t('check_in.enter_card_details') : "Please enter your card details. These will be verified against your booking."} </p>
                                <StripeElementsProvider 
                                    publishableKey={this.props.publishableKey}
                                    setupIntentClientSecret={this.props.setupIntentClientSecret}
                                    setCardverified={(status) => this.props.setCardverified(status)} 
                                    setError={(error) => this.props.setError(error)}
                                    cardverified={this.props.cardverified}
                                    showLoader={bool => this.props.showLoader(bool)}
                                    confirmationNumber={this.props.confirmationNumber}
                                    firstName={this.props.firstName}
                                    lastName={this.props.lastName}
                                    next={this.props.next}
                                    showFailScreen={(status, message) => this.props.showFailScreen(status, message)} 
                                    setcardVerified={(status, token) => this.props.setcardVerified(status, token)}
                                    iscardVerified={this.props.iscardVerified}
                                    showCardVerified={this.props.showCardVerified}
                                    countryOptions={this.props.countryOptions}
                                    guestBookFormData={this.props.guestBookFormData}
                                    goBack={this.props.goBack}
                                    canSkipCardValidation={this.props.canSkipCardValidation}
                                    />
                            </div>
                        </div>
                    : 
                        <div class="form-window">
                            <div class="form-window-heading">
                                Card verified
                            </div>
                            <div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                                <div class="form-row margin-bottom-1">
                                <p>Your card was successfully verified.</p> {/* **** **** **** 4242  */}
                                    <p>Tap on NEXT to proceed</p> 
                                </div>
                                <div class="form-controls">
                                    {/* <button class="secondary w-100 margin-bottom-1">Change card</button>  */}
                                    <button disabled={!this.state.cardverified} className="primary w-100" onClick = {() => this.props.next({firstName: this.props.firstName, lastName: this.props.lastName })}>{t('check_in.next')}</button>
                                </div>
                            </div>
                        </div>}
                    </div>
                </section>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
    }
}

export default connect(mapStateToProps, {
    setCardStatusPopupProps
})(withTranslation('translations')(AddCard));